module.exports = __webpack_public_path__ + "1bd52a0ef5d6161f9bf652485feb60e3.MP3";